import CompareMixin from '../components/filters/compare-mixin'
import { filters } from '../constants'
import { getComparisonLabel, normalizeSettingsForShowAll } from './shared'

export const formulaDefinition = {
  type: filters.FORMULA,
  nameKey: 'formula',
  ledgerRequired: true,

  comparisonModes() {
    return [
      ...CompareMixin.computed.numberComparisonModes(),
      ...CompareMixin.computed.showAllComparisonMode(),
    ]
  },

  activeSubtitle(settings) {
    const { formula, comparisonMode, comparisonValue } = settings
    const comparisonLabel = getComparisonLabel(
      comparisonMode,
      this.comparisonModes()
    )

    return `${formula} ${comparisonLabel} ${comparisonValue || ''}`
  },

  normalizeSettings(settings) {
    return normalizeSettingsForShowAll(settings, 'comparisonValue')
  },

  serializeSettings(settings) {
    return {
      comparison_mode: settings.comparisonMode,
      comparison_value: settings.comparisonValue,
      formula: settings.formula,
    }
  },

  deserializeSettings(params) {
    return {
      comparisonMode: params.comparison_mode,
      comparisonValue: params.comparison_value,
      formula: params.formula,
    }
  },
}
